import { PortainerSelect } from '@/react/components/form-components/PortainerSelect';

import { SearchBar } from '@@/datatables/SearchBar';

import { PolicyCategory } from '../../types';

type EnvironmentTypeFilter =
  | 'all'
  | 'kubernetes'
  | 'docker'
  | 'podman'
  | 'swarm';
type CategoryFilter = 'all' | PolicyCategory;

interface Props {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
  environmentFilter: EnvironmentTypeFilter;
  environmentFilterOptions: Array<{
    value: EnvironmentTypeFilter;
    label: string;
  }>;
  onEnvironmentFilterChange: (filter: EnvironmentTypeFilter) => void;
  categoryFilter: CategoryFilter;
  categoryFilterOptions: Array<{ value: CategoryFilter; label: string }>;
  onCategoryFilterChange: (filter: CategoryFilter) => void;
}

export function PolicyTypeToolbar({
  searchQuery,
  onSearchQueryChange,
  environmentFilter,
  environmentFilterOptions,
  onEnvironmentFilterChange,
  categoryFilter,
  categoryFilterOptions,
  onCategoryFilterChange,
}: Props) {
  return (
    <div className="toolBar vertical-center relative w-full !gap-x-5 !gap-y-1 !px-0 overflow-auto mb-4">
      <SearchBar
        value={searchQuery}
        onChange={onSearchQueryChange}
        placeholder="Search policy types..."
        data-cy="policy-search"
        className="!mr-0 h-9"
      />

      <div className="w-full sm:w-1/4 flex-none [&_.portainer-selector__control]:!min-h-[36px] [&_.portainer-selector__control]:!h-9">
        <PortainerSelect
          placeholder="Environment type"
          value={environmentFilter}
          options={environmentFilterOptions}
          onChange={(newValue) => onEnvironmentFilterChange(newValue || 'all')}
          isClearable
          bindToBody
          data-cy="policy-environment-filter"
        />
      </div>

      <div className="w-full sm:w-1/4 flex-none [&_.portainer-selector__control]:!min-h-[36px] [&_.portainer-selector__control]:!h-9">
        <PortainerSelect
          placeholder="Category"
          value={categoryFilter}
          options={categoryFilterOptions}
          onChange={(newValue) => onCategoryFilterChange(newValue || 'all')}
          isClearable
          bindToBody
          data-cy="policy-category-filter"
        />
      </div>
    </div>
  );
}
